"use client";

import React, { useEffect, useRef, useState } from 'react';
import { useI18n } from "@/app/components/LanguageProvider";

const values = [
  { key: "Transparency", gradient: "from-blue-400/20 to-cyan-300/20" },
  { key: "Courage", gradient: "from-purple-400/20 to-pink-300/20" },
  { key: "Curiosity", gradient: "from-yellow-400/20 to-orange-300/20" },
  { key: "DataDriven", gradient: "from-green-400/20 to-emerald-300/20" }
];

export default function ValuesCarousel() {
  const { t } = useI18n();
  const swiperRef = useRef<HTMLDivElement>(null);
  const [swiperLoaded, setSwiperLoaded] = useState(false);

  useEffect(() => {
    setSwiperLoaded(true);
  }, []);

  useEffect(() => {
    if (!swiperLoaded || !swiperRef.current) return;
    let swiperInstance: { destroy: () => void } | null = null;

    import('swiper').then(({ default: Swiper }) => {
      import('swiper/modules').then(({ Autoplay, Pagination }) => {
        import('swiper/css').catch(() => {});
        import('swiper/css/pagination').catch(() => {});

        if (swiperRef.current && !(swiperRef.current as { swiper?: unknown }).swiper) {
          swiperInstance = new Swiper(swiperRef.current, {
            modules: [Autoplay, Pagination],
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            autoplay: {
              delay: 3500,
              disableOnInteraction: false,
            },
            pagination: {
              el: '.values-pagination',
              clickable: true,
            },
          });
        }
      });
    });

    return () => {
      swiperInstance?.destroy();
    };
  }, [swiperLoaded]);

  return (
    <div className="relative">
      <div 
        ref={swiperRef}
        className="swiper"
      >
        <div className="swiper-wrapper">
          {values.map((value, index) => (
            <div className="swiper-slide" key={index}>
              <div className="min-h-[200px] flex flex-col justify-center text-center pb-10">
                <p className="text-white/60 max-w-2xl mx-auto text-sm">
                  {t(`value${value.key}Desc`, "About")}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="values-pagination flex justify-center gap-2 mb-16"></div>
      <style jsx>{`
        .values-pagination :global(.swiper-pagination-bullet) {
          width: 8px;
          height: 8px;
          background: rgba(255, 255, 255, 0.3);
          opacity: 1;
          transition: all 0.3s ease;
        }
        .values-pagination :global(.swiper-pagination-bullet-active) {
          background: white;
          transform: scale(1.2);
        }
      `}</style>
    </div>
  );
}
